<div class="hidden md:flex z-[1] absolute top-0 left-0 overflow-hidden h-screen w-screen self-center"><img
        class="min-h-[100vh] min-w-[100vw]" style="object-fit: cover;" src="../../assets/login_background.png"></div>
<div class="w-screen h-screen overflow-y-scroll flex place-content-center items-center bg-tertiary absolute top-0 left-0 z-[2] cut-bg"
    *transloco="let t;prefix:'auth'">
    <div class="md:w-[350px] grid pb-[10vh] h-screen">
        <div title class="text-[48px] pt-[20px] font-bold text-center mx-[18px] text-primary italic">
            <img class="" [src]="'../assets/logoAuth.png'" />
        </div>

        <div class="ml-auto w-full pb-10 text-primary px-10 text-title text-center">
            Pagamento cancellato torna all'app
            <!-- <std-button (click)="goToApp()" id="button-login" size="sm"
                buttonClass="uppercase bg-primary hover:bg-primary focus:bg-primary">{{t('enter')}}</std-button> -->
        </div>
        <div class="ml-auto w-full pb-10">
            <std-button (click)="goToApp()" id="button-login" size="sm"
                buttonClass="uppercase bg-primary hover:bg-primary focus:bg-primary">Torna all'app</std-button>
        </div>
    </div>
</div>